import { render, staticRenderFns } from "./FaqFeedback.vue?vue&type=template&id=667d2f7c&scoped=true"
import script from "./FaqFeedback.vue?vue&type=script&lang=js"
export * from "./FaqFeedback.vue?vue&type=script&lang=js"
import style0 from "./FaqFeedback.vue?vue&type=style&index=0&id=667d2f7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d2f7c",
  null
  
)

export default component.exports